import { Brand } from 'node_modules/@schibsted-nmp/advertising-shared/src/index.js';

import { $config } from '@client/core/atoms/config.js';

export function sizeIsNativeAd(
  size: googletag.events.SlotRenderEndedEvent['size']
) {
  return Array.isArray(size) && size[0] === 0 && size[1] === 0;
}

export function eventIsNativeCpmAd(
  event: googletag.events.SlotRenderEndedEvent & {
    // TODO: check up on this property, as it seems it should come from elsewhere, e.g. `googletag.ResponseInformation`:
    creativeTemplateId?: number;
  }
) {
  const nativeCpmCreativeTemplateIds = [12399765];

  return Boolean(
    event.creativeTemplateId &&
      nativeCpmCreativeTemplateIds.includes(event.creativeTemplateId)
  );
}

export function sizeIsFullScreenAd(
  size: googletag.events.SlotRenderEndedEvent['size']
) {
  return (
    Array.isArray(size) &&
    (
      (size[0] === 1920 && size[1] === 1080) ||
      (size[0] === 640 && size[1] === 1136)
    )
  );
}


export function sizeIsAdnami(
  size: googletag.events.SlotRenderEndedEvent['size']
) {
  return Array.isArray(size) && size[0] === 1 && size[1] === 2;
}

export function sizeIsDbaDesktopIntermingle(
  size: googletag.events.SlotRenderEndedEvent['size']
) {
  if (!Array.isArray(size)) return false;

  return (
    (size[0] === 930 && size[1] === 180) ||
    (size[0] === 970 && size[1] === 250) ||
    (size[0] === 970 && size[1] === 188) ||
    sizeIsPrebid(size)
  );
}

export function sizeExceedsCenterContentWidth(
  size: googletag.events.SlotRenderEndedEvent['size']
) {
  if (!Array.isArray(size)) return false;

  const { brand } = $config.get() ?? {};
  const isDba = brand === Brand.Dba;
  if (sizeIsPrebid(size) && isDba) return true;

  const CENTER_CONTENT_WIDTH_LIMIT = 640; // TODO: temp threshold, should be verified with design team
  return (size[0] ?? 0) > CENTER_CONTENT_WIDTH_LIMIT;
}

function sizeIsPrebid(size: googletag.events.SlotRenderEndedEvent['size']) {
  return size[0] === 1 && size[1] === 1;
}

export function sizeBlocketTop1Wallpaper(
  size: googletag.events.SlotRenderEndedEvent['size']
) {
  if (!Array.isArray(size)) return false;

  return size[0] === 1600 && size[1] === 900;
}
